import { qsa } from "@fluorescent/dom";
import { emit } from "@/glow/events";
import simpleParallax from "simple-parallax-js";
import { section } from "@/glow";

section("full-width-image", {
  onLoad() {
    const { parallaxScale, enableParallax } = this.container.dataset;
    const images = qsa(".responsive-image__image", this.container);

    if (!images.length || !enableParallax) return;

    this.parallaxElements = images.map(image => {
      return new simpleParallax(image, {
        scale: parallaxScale,
      });
    });
  },

  onSelect() {
    emit("transparentSectionUpdate");
  },

  onUnload() {
    this.parallaxElements &&
      this.parallaxElements.forEach(element => element.destroy());
  },
});
